<div class="center">
    <div class="d-flex justify-content-center" [class._input]="!readonly" [class.cursor-pointer]="!readonly" *ngIf="!focus">
        <span class="prefix" *ngIf="options?.prefix && value"><i class="fa fa-{{options?.prefix}}"></i></span>
        <!-- <input class="text-center" type="number" [value]="value" placeholder="00.00"> -->
        <span class="text-overflow">{{value}}</span>
    </div>
    <input #input class="text-center" type="text" [value]="value" placeholder="Aa..." *ngIf="focus" (blur)="setFocus(false)" (change)="emitValue(input.value); setFocus(false)">
</div>